import React from "react";
import { Container, Typography } from "@mui/material";

const PrivacyPolicy = () => {
    return (
        <Container maxWidth="md" style={{ padding: "2rem" }}>
            <Typography variant="h4" gutterBottom>
                Privacy Policy
            </Typography>
            <Typography variant="body1" paragraph>
                This privacy policy applies to the Alfadatizando app (hereby referred to as
                "Application") for mobile devices that was created by the Service Provider as an
                Open Source service. This service is intended for use "AS IS".
            </Typography>
            <Typography variant="h6">Information Collection and Use</Typography>
            <Typography variant="body1" paragraph>
                The Application collects information when you download and use it, including:
            </Typography>
            <ul>
                <li>Your device's Internet Protocol address (e.g., IP address).</li>
                <li>
                    The pages of the Application that you visit, time and date of your visit, and
                    time spent on those pages.
                </li>
                <li>The operating system you use on your mobile device.</li>
            </ul>
            <Typography variant="body1" paragraph>
                The Application does not gather precise location information from your device.
            </Typography>

            <Typography variant="h6">Third Party Access</Typography>
            <Typography variant="body1" paragraph>
                The Application uses third-party services that have their own privacy policies
                regarding data handling:
            </Typography>
            <ul>
                <li>
                    <a
                        href="https://www.google.com/policies/privacy/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Google Play Services
                    </a>
                </li>
            </ul>

            <Typography variant="h6">Opt-Out Rights</Typography>
            <Typography variant="body1" paragraph>
                You can stop all collection of information by uninstalling the Application via your
                device’s standard uninstall process.
            </Typography>

            <Typography variant="h6">Data Retention Policy</Typography>
            <Typography variant="body1" paragraph>
                User-provided data is retained as long as you use the Application. If you wish to
                delete your data, contact info.alfadatizando@gmail.com.
            </Typography>

            <Typography variant="h6">Children</Typography>
            <Typography variant="body1" paragraph>
                The Service Provider does not knowingly collect data from children under the age of
                13. If you are a guardian and believe your child has provided information, contact
                info.alfadatizando@gmail.com.
            </Typography>

            <Typography variant="h6">Security</Typography>
            <Typography variant="body1" paragraph>
                The Service Provider takes reasonable measures to safeguard the confidentiality of
                your information.
            </Typography>

            <Typography variant="h6">Changes</Typography>
            <Typography variant="body1" paragraph>
                This Privacy Policy may be updated from time to time. Continued use of the
                Application constitutes acceptance of changes.
            </Typography>

            <Typography variant="h6">Contact</Typography>
            <Typography variant="body1">
                If you have any questions, contact info.alfadatizando@gmail.com.
            </Typography>
        </Container>
    );
};

export default PrivacyPolicy;
